// extracted by mini-css-extract-plugin
export default {"container":"root_notifications-tester-module__container___YDAki","expanded":"root_notifications-tester-module__expanded___nMipM"};